import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-chats"
export default class extends Controller {
  static targets = ["list", "buttonIcon", "spinner", "frame"]

  isListOpen = false
  isLoaded = false

  connect() {
    if (this.hasFrameTarget) {
      this.observer = new MutationObserver(() => {
        if (this.frameTarget.innerHTML.trim() !== "") {
          this.hideSpinnerWhenReady()
        }
      })
      this.observer.observe(this.frameTarget, { childList: true, subtree: true })
    }
  }

  toggleNestedList(event) {
    if (!this.isLoaded) {
      this.toggleSpinnerVisibility(false)
    }

    if (this.isListOpen && this.isLoaded) {
      event.preventDefault()
    }

    const icon = this.buttonIconTarget
    const list = this.listTarget

    if (icon) {
      icon.classList.toggle("rotated")
    }

    if (list) {
      list.classList.toggle("open")
    }

    this.isListOpen = !this.isListOpen
  }

  hideSpinnerWhenReady() {
    this.toggleSpinnerVisibility(true)
    this.isLoaded = true
  }

  toggleSpinnerVisibility(flag) {
    this.spinnerTarget.classList.toggle("hidden", flag)
  }
}
